import axios from 'axios';

import {
  createTicketsNoProduct,
  getTickets,
  selfServiceByMotive,
  validateProductByMotive,
} from '../config/paths';
import axiosInstance from '../providers/Axios';

export const callGetTicketMicroFront = async (host) => {
  return axios.get(`${host}/asset-manifest.json`);
};
// RESOLVE: this function must to be called? callGetTicketMicroFront;

export const callGetCustomerTickets = async (id) => {
  return axiosInstance({
    url: `${getTickets}/${id}`,
    method: 'get',
  });
};

export const callValidateProductByMotive = async (motiveId, data) => {
  return axiosInstance({
    url: `${validateProductByMotive}/${motiveId}/product/validation`,
    method: 'post',
    data: data,
  });
};

export const callMakeSelfServiceByMotive = async (logonId, motiveId, data) => {
  return axiosInstance({
    url: `${selfServiceByMotive}/customer/${logonId}/motive/${motiveId}`,
    method: 'post',
    data: data,
  });
};

export const callCreateTicketNoProduct = async (logonId, data) => {
  return axiosInstance({
    url: `${createTicketsNoProduct}/${logonId}`,
    method: 'post',
    data: data,
  });
};
